
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512","stroke":"currentColor","fill":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M480.8 33.92c-9.438-3.859-19.66-1.812-26.84 5.346l-66.36 66.38A201.948 201.948 0 00254.9 56c-98.86 0-182.5 70.09-198.8 166.7-.72 4.3 2.21 8.5 6.57 9.2 6.71 1.1 8.99-5.2 9.22-6.6C86.92 136.5 163.9 72 254.9 72c44.73 0 87.58 16.11 121.3 45.05l-64.96 64.98c-7.188 7.176-9.219 17.46-5.344 26.84 3.789 9.172 12.23 14.87 22.1 15.12h143.9C485.3 223.7 496 212.9 496 199.4V56.68c0-10.14-5.8-18.87-15.2-22.76zM480 199.4c0 4.752-3.875 8.629-8.625 8.629h-142.7c-7.684 0-11.53-9.291-6.094-14.72l142.7-142.8C470.3 45.57 480 48.44 480 56.68V199.4zm-30.7 80.7c-4.266-.625-8.484 2.203-9.219 6.562C425.1 375.5 348.1 440 257.1 440c-44.73 0-87.58-16.11-121.3-45.05l64.96-64.98c7.188-7.174 9.234-17.62 5.359-26.99C202.3 293.8 193.8 288.3 183.1 288H40.05C26.68 288.3 16 299.1 16 312.6v142.8c0 10.14 5.812 18.87 15.19 22.76 9.438 3.861 19.66 1.814 26.84-5.346l66.36-66.38A202.28 202.28 0 00257.1 456c98.86 0 182.5-70.09 198.8-166.7.7-5.2-2.2-8.5-6.6-9.2zM46.72 461.4c-5.06 5.1-14.72 2.1-14.72-6.1V312.6c0-4.752 3.875-8.629 8.625-8.629h142.7c7.684 0 11.53 9.289 6.094 14.72L46.72 461.4z"}})])
          )
        }
      }
    